var PIVOT_IMPORT_ERROR_KEYS, Project, Question, W, ensureIds, generateGUID, hasImportedAbsoluteEffect, importMapper, maybeRecalculateOutcome, parseFile, parseSofJson, translateImportError;

Project = require('models/project');

Question = require('models/question');

W = require('when');

generateGUID = require('base/lib/utils').generateGUID;

importMapper = require('lib/services/cochrane_pivot/import_mapper');

PIVOT_IMPORT_ERROR_KEYS = {
  unsupportedCiLevel: 'projects:import_dialog.unsupported_ci_level',
  tooManyAbsoluteEffects: 'projects:import_dialog.too_many_absolute_effects',
  tooManyCalculatedAbsoluteEffects: 'projects:import_dialog.too_many_calculated_absolute_effects',
  invalidPivotFormat: 'projects:import_dialog.invalid_pivot_format'
};

translateImportError = function(error) {
  var key;
  key = PIVOT_IMPORT_ERROR_KEYS[error != null ? error.message : void 0];
  if (key) {
    return new Error($.t(key));
  } else {
    return error;
  }
};

ensureIds = function(question) {
  var _ref;
  if (question._id == null) {
    question._id = generateGUID();
  }
  _.each((_ref = question.outcomes) != null ? _ref : [], function(outcome) {
    return outcome._id != null ? outcome._id : outcome._id = generateGUID();
  });
  return question;
};

hasImportedAbsoluteEffect = function(outcome) {
  return _.some(['absEffectSize', 'absEffectFrom', 'absEffectTo', 'absEffectSizeLow', 'absEffectFromLow', 'absEffectToLow', 'absEffectSizeModerate', 'absEffectFromModerate', 'absEffectToModerate', 'absEffectSizeHigh', 'absEffectFromHigh', 'absEffectToHigh'], function(key) {
    return outcome.get(key) != null;
  });
};

maybeRecalculateOutcome = function(outcome) {
  if (!_.isFunction(outcome.recalculateOutcomeData)) {
    return;
  }
  if (hasImportedAbsoluteEffect(outcome)) {
    return;
  }
  return outcome.recalculateOutcomeData();
};

parseSofJson = function(json) {
  var error, questions, sofList;
  sofList = (function() {
    try {
      return importMapper.normalizeSofList(json);
    } catch (_error) {
      error = _error;
      throw translateImportError(error);
    }
  })();
  questions = _.map(sofList, function(sof, idx) {
    var attrs, question, _ref;
    attrs = (function() {
      try {
        return importMapper.importSof(sof);
      } catch (_error) {
        error = _error;
        throw translateImportError(error);
      }
    })();
    ensureIds(attrs);
    question = new Question(_.extend(attrs, {
      questionNo: idx + 1
    }));
    if ((_ref = question.get('outcomes')) != null ? _ref.each : void 0) {
      question.get('outcomes').each(maybeRecalculateOutcome);
    }
    return question;
  });
  if (!questions.length) {
    throw new Error($.t('projects:import_dialog.no_questions_in_pivot_file'));
  }
  return questions;
};

parseFile = function(file) {
  var reader, readingFile;
  readingFile = W.defer();
  reader = new FileReader();
  reader.onload = function(loadEvent) {
    var error;
    try {
      return readingFile.resolve(loadEvent.target.result);
    } catch (_error) {
      error = _error;
      return readingFile.reject(error);
    }
  };
  reader.onerror = function() {
    return readingFile.reject(reader.error);
  };
  reader.readAsText(file, 'utf-8');
  return readingFile.promise.then(function(text) {
    var json, project, projectName, questions, _ref;
    json = (function() {
      try {
        return JSON.parse(text);
      } catch (_error) {
        throw new Error($.t('projects:import_dialog.invalid_format'));
      }
    })();
    questions = parseSofJson(json);
    projectName = ((_ref = questions[0]) != null ? _ref.get('tableTitle') : void 0) || file.name;
    project = new Project({
      name: projectName
    });
    return [
      {
        project: project,
        questions: questions
      }
    ];
  });
};

module.exports = {
  parseFile: parseFile,
  parseSofJson: parseSofJson
};
